module.exports = __webpack_public_path__ + "static/media/bw.15ed460a.svg";